import script from "./InsightsSales.vue?vue&type=script&setup=true&lang=js"
export * from "./InsightsSales.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__